<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="main">
      <el-form :model="append" ref="ruleForm" label-position="right"  class="mainfrom from_input">
        <div class="row">
          <el-form-item label="顺序号">
            <el-input v-model="append.appendseq" :maxlength="4" :disabled="disable"></el-input>
          </el-form-item>

          <el-form-item label="附件类型" prop="appendtype" verify>
            <el-select v-model="append.appendtype" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in appendTypeList" :label="item.label" :value="item.value" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
            <el-form-item label="附件编号">
              <el-input v-model="append.appendfilecode" :maxlength="128" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="附件名称" prop="appendfilename" verify>
              <el-input v-model="append.appendfilename" :maxlength="128" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
        </div>
        <el-form-item label="URL" prop="appendurl" verify>
          <upload-pic-one @changed="setPic" :picUrl="append.appendurl" folderName="web" text="选择文件"></upload-pic-one>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import common from '@/mixin/common'

  export default {
    name: "appendForm",
    mixins: [common],
    data () {
      return {
        append: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        appendTypeList: [],
        btnLoading: false
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getAppendType()
    },
    watch: {
    },
    filters: {
    },
    components: {uploadPicOne},
    computed: {
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      async init() {
        this.append = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.appendTypeList = []
      },
      async getAppendType() {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode:'appendtype'}
        })
      },
      async setPic  (path) {
        this.$set(this.append, 'appendurl' ,path.replace(this.uploadAddr,''))
        // console.log(path.replace(this.uploadAddr,''))
        // this.append.appendurl = path.replace(this.uploadAddr,'')
      },
      async addOrEdit () {
        console.log(this.append)
        this.submitForm('ruleForm').then(async() => {
          let data = await request({
            url: '/ywgl/append/addOrEdit',
            method: "post",
            data: this.append
          })
          if (data.issuccess===1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {})

      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: this.append.returnForm})
      }
    }
  }
</script>


<style lang="scss" scoped>

  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 520px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
  }
</style>
